import React, { useState, useEffect } from "react";
import { Toaster } from "react-hot-toast";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import { RestaurantProvider } from "./context/RestaurantContext";
import EmailAuth from "./components/Auth/EmailAuth";
import OTPVerify from "./components/Auth/OTPVerify";
import MainApp from "./components/MainApp";
import "./App.css";

function AppContent() {
  const { user, loading, step, setStep } = useAuth();
  const [email, setEmail] = useState("");
  const [location, setLocation] = useState(null);

  useEffect(() => {
    if (!loading) {
      const savedLocation = localStorage.getItem("gutful_user_location");
      if (user) {
        if (savedLocation) {
          setLocation(JSON.parse(savedLocation));
          setStep("main");
        } else {
          setStep("location");
        }
      } else {
        // For guest users, still allow them to see the main page
        if (savedLocation) {
          setLocation(JSON.parse(savedLocation));
          setStep("main");
        } else {
          setStep("location");
        }
      }
    }
  }, [user, loading, setStep]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-green-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (step === "email") {
    return (
      <EmailAuth
        onOTPSent={(email) => {
          setEmail(email);
          setStep("otp");
        }}
      />
    );
  }

  if (step === "otp") {
    return <OTPVerify email={email} onBack={() => setStep("email")} />;
  }

  return (
    <MainApp
      location={location}
      onLocationSet={setLocation}
      onLoginClick={() => setStep("email")}
    />
  );
}

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <RestaurantProvider>
          <Toaster position="top-center" />
          <AppContent />
        </RestaurantProvider>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
